import { useListContext } from "react-admin";

const IndexField = ({ record }) => {
  const { data, page, perPage } = useListContext();
  const currentPage = page;
  const itemsPerPage = perPage;

  // Find the index of the current record in the data array
  const recordIndex = data.findIndex((item) => item.id === record.id);

  // Calculate the global counter
  const sequentialNumber = (currentPage - 1) * itemsPerPage + recordIndex + 1;

  return <span>{sequentialNumber}</span>;
};

export default IndexField;
export { IndexField };